module.exports = __webpack_public_path__ + "static/media/QUICK.0dc6c052.png";